import careerOffice from "@content/img/job-market/cards/career-office.svg";
import careerTeam from "@content/img/job-market/cards/career-team.svg";
import careerGrowth from "@content/img/job-market/cards/career-growth.svg";
import careerHandshake from "@content/img/job-market/cards/career-handshake.svg";
import careerLaptop from "@content/img/job-market/cards/career-laptop.svg";
import careerBriefcase from "@content/img/job-market/cards/career-briefcase.svg";

export const JOB_MARKET_STOCK_IMAGES = [
  careerOffice,
  careerTeam,
  careerGrowth,
  careerHandshake,
  careerLaptop,
  careerBriefcase,
];

export function getJobMarketStockImage(id) {
  const index = Math.abs(Number(id) || 0) % JOB_MARKET_STOCK_IMAGES.length;
  return JOB_MARKET_STOCK_IMAGES[index];
}
